import { InfoCircleOutlined } from '@ant-design/icons'
import { Card } from 'antd'

import ProductSourceEditUpload from './ProductSourceEditUpload'
import BatchImportProvider from '../../../context/BatchImportContext'
import TemplateDownload from '../../TemplateDownload'

function EditBatchProductSource(): JSX.Element {
  return (
    <BatchImportProvider initialMode="upt">
      <h1 className="pb-4">Update Existing Products</h1>
      <Card
        title={<TemplateDownload type="product" />}
        className="pt-4 [&>.ant-card-body]:py-4 [&>.ant-card-head]:border-none"
      >
        <ProductSourceEditUpload />
        <Card.Meta
          className="pt-4"
          description={
            <p className="text-xs">
              <InfoCircleOutlined className="mr-1 text-primary-600" />
              This file only updates products. Each row must include the
              existing Product ID.
            </p>
          }
        />
      </Card>
    </BatchImportProvider>
  )
}

export default EditBatchProductSource
